import { NgModule }       from '@angular/core';
import {CommonModule} from '@angular/common'
import {TranslateModule} from '@ngx-translate/core';
import {ContactRoutingModule} from "./contact-routing.module";
import {ContactComponent} from "./contact.component";
import {SharedModule} from "../../shared/shared.module";

@NgModule({
    imports: [CommonModule, ContactRoutingModule, TranslateModule, SharedModule],
    declarations: [
        ContactComponent,
    ]
})
export class ContactModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/contact/contact.module.ts